<template>
    <div>
        <Dialog v-model:visible="state.visible" :style="{ width: '600px' }" header="Configure step details for the block" :modal="true" @hide="emit('hide-dialog', true)" :closable="false">
            <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-6">
                    <label for="label">Label*</label>
                    <InputText maxlength = "255" id="label" :class="{ 'p-invalid': state.submitted && !state.step.label }" v-model="state.step.label" placeholder="Input a label for step" />
                    <small id="labelError" class="p-invalid" v-if="state.submitted && !state.step.label">Step label is required.</small>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="code">Code*</label>
                    <InputText disabled maxlength = "255" id="code" :class="{ 'p-invalid': state.submitted && !state.step.code }" v-model="state.step.code" placeholder="Input a unique step code" />
                    <small id="codeError" class="p-invalid" v-if="state.submitted && !state.step.code">Step Code is required.</small>
                </div>
                <div class="field col-12">
                    <label for="description">Description</label>
                    <Textarea id="description" rows="4" v-model="state.step.description" />
                </div>
            </div>
            <template #footer>
                <Button label="Cancel" icon="pi pi-times" class="mx-1 p-button-danger" @click="emit('hide-dialog', true)" />
                <Button label="Submit" icon="pi pi-check" class="mx-1 p-button-primary" @click="submit" />
            </template>
        </Dialog>
    </div>
</template>

<script setup>
import { reactive, inject, defineEmits, onMounted } from 'vue';
import { storeToRefs } from 'pinia';

const emit = defineEmits(['hide-dialog', 'step-added']);
const stepStore = inject('stepStore');
const builderStore = inject('builderStore');
const assessmentId = inject('assessmentId');

const { steps } = storeToRefs(stepStore);

const createInitialState = () => {
    return reactive({
        step: stepStore.initateStepDetails(),
        submitted: false,
        visible: true,
    });
};

const state = createInitialState();

onMounted(() => {
    state.step.label = builderStore.activeBlock.name;
    state.step.code = 'step' + steps.value.length;
});

const submit = async () => {
    state.submitted = true;
    // check if valid
    if (isValid()) {
        // add the remaining details to the step body before submission
        createStepBody();
        // submit step
        const newStep = await stepStore.addStep(state.step);
        if (newStep?.id) {
            // if step is created then flush the current step
            state.step = stepStore.initateStepDetails();
            emit('step-added', true);
        }
    }
};

function createStepBody() {
    state.step.assessment_id = parseInt(assessmentId);
    state.step.block_id = builderStore.activeBlock?.id;
    // check the counts of blocks/steps
    // if this is the first step or block, make it the entry point
    state.step.entry = setEntryValue();
}

function setEntryValue() {
    return builderStore.droppedBlocks?.length <= 0 ? 1 : 0;
}

function isValid() {
    if (!state.step.label && !state.step.code) {
        return false;
    }
    return true;
}
</script>
